<template>
    <div>
        <div class="footer">
            <div class="container">
                <div class="row">
                    <!-- About -->
                    <div class="col-md-6 col-lg-3 footer-about mb-4">
                        <router-link to="/">
                            <img class="img align-middle"
                                src="../assets/img/logo.png"
                                alt="PREFERE PLUS - Cabinet Conseil RH"
                                width="140"
                                height="auto"
                            />
                        </router-link>
                        <p class="mt-3">
                            Cabinet conseil en Management des Ressources Humaines depuis 2012. Avec nous, boostez votre performance.
                        </p>
                        <div class="social-links">
                            <a href="https://www.facebook.com/prefereplus" target="_blank" rel="noopener" aria-label="Facebook">
                                <i class="fab fa-facebook-f"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/prefereplus" target="_blank" rel="noopener" aria-label="LinkedIn">
                                <i class="fab fa-linkedin-in"></i>
                            </a>
                            <a href="https://twitter.com/prefereplus" target="_blank" rel="noopener" aria-label="Twitter">
                                <i class="fab fa-twitter"></i>
                            </a>
                            <a href="https://wa.me/22901401188884" target="_blank" rel="noopener" aria-label="WhatsApp">
                                <i class="fab fa-whatsapp"></i>
                            </a>
                        </div>
                    </div>

                    <!-- Liens rapides -->
                    <div class="col-md-6 col-lg-3 mb-4">
                        <div class="footer-link">
                            <h3>Navigation</h3>
                            <router-link to="/">Accueil</router-link>
                            <router-link to="/about">Qui sommes-nous</router-link>
                            <router-link to="/services">Nos services</router-link>
                            <router-link to="/formations">Formations 2026</router-link>
                            <router-link to="/job-offers">Offres d'emploi</router-link>
                        </div>
                    </div>

                    <!-- Ressources -->
                    <div class="col-md-6 col-lg-3 mb-4">
                        <div class="footer-link">
                            <h3>Ressources</h3>
                            <router-link to="/contact">Nous contacter</router-link>
                            <router-link to="/register">S'inscrire</router-link>
                        </div>
                    </div>

                    <!-- Contact -->
                    <div class="col-md-6 col-lg-3 mb-4">
                        <div class="footer-contact">
                            <h3>Nous joindre</h3>
                            <p>
                                <a class="contact-link" href="tel:+22901401188884">
                                    <i class="fas fa-phone-alt"></i> 01 40 11 88 84
                                </a>
                            </p>
                            <p>
                                <a class="contact-link" href="mailto:prefereplus@gmail.com">
                                    <i class="fas fa-envelope"></i> prefereplus@gmail.com
                                </a>
                            </p>
                            <p>
                                <a class="contact-link" href="https://maps.app.goo.gl/DWsfXaaCCjjWNnV7A" target="_blank" rel="noopener">
                                    <i class="fas fa-map-marker-alt"></i> Carre 808, Aidjedo - Cotonou, Benin
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container copyright">
                <div class="row">
                    <div class="col-md-12">
                        <p>&copy; {{ currentYear }} PREFERE PLUS by <a href="https://www.xtopdigital.com" target="_blank" rel="noopener">XTOP DIGITAL</a> - Tous droits reserves.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="css">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');
@import '../assets/styles/footer-1.css';

.social-links {
    display: flex;
    gap: 0.6rem;
    margin-top: 1rem;
}

.social-links a {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255,255,255,0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e95d16;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    text-decoration: none;
}

.social-links a:hover {
    background: #fff;
    transform: translateY(-3px);
}

.footer-about p {
    font-size: 0.9rem;
    line-height: 1.6;
    opacity: 0.85;
}

.contact-link {
    color: rgba(255,255,255,0.8);
    text-decoration: none;
    transition: color 0.3s;
    font-size: 0.9rem;
}

.contact-link:hover {
    color: #e95d16;
}

.contact-link i {
    color: #e95d16;
    width: 20px;
    margin-right: 6px;
}

.footer-contact p {
    margin-bottom: 0.6rem;
}
</style>

<script>
export default {
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
}
</script>
